import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CategoryStatus, CategoryStatusAppData, ChallengeResult, UpdateType } from "@model";

@Injectable({ providedIn: "root" })
export class CategoryStatusDataService {
  private _categoryStatusData$ = new BehaviorSubject<CategoryStatusAppData | null>(null);
  categoryStatusData$ = this._categoryStatusData$.asObservable();

  constructor() {
    this._getCategoryStatusDataFromStorage();
  }

  setData(categoryStatusAppData: CategoryStatusAppData) {
    this._categoryStatusData$.next(categoryStatusAppData);
  }

  private _getCategoryStatusDataFromStorage() {
    // TODO get from storage
  }

  updateLocally(challengeResult: ChallengeResult) {
    const { category_id, level_id, variant_id, result } = challengeResult;

    const currentData = this._categoryStatusData$.value?.data;

    if (!currentData) {
      return;
    }

    const updatedData: CategoryStatus[] = currentData.map((c) => {
      const levels = c.levels.map((l) => {
        const variants = l.variants.map((v) => {
          if (
            c.category_id === category_id &&
            l.level_id === level_id &&
            v.variant_id === variant_id
          ) {
            return {
              ...v,
              previousResult: v.result,
              result: result,
            };
          } else {
            return v;
          }
        });
        return {
          ...l,
          variants,
        };
      });
      return {
        ...c,
        levels,
      };
    });

    this._categoryStatusData$.next({ data: updatedData, lastUpdateType: UpdateType.LOCAL });
  }
}
